<template>
    <div ref="tooltip" class="tooltip" :class="[tooltip_status, tooltip_position]" :style="'top: ' + tooltip_top + 'px; left: ' + tooltip_left + 'px'">
        <small class="arrow" :style="'left: ' + arrow_left + 'px'"></small>
        <span>{{Language.say(TooltipController.text)}}</span>
    </div>
</template>

<script setup>
  import { nextTick, ref, watch } from "vue";
  import TooltipController        from '@/js/Webmail/TooltipController.js';
  import Language                 from '@/js/Shared/Language/Language.js';

  const tooltip          = ref();
  const tooltip_status   = ref('tooltip-hidden');
  const tooltip_position = ref('');
  const tooltip_top      = ref();
  const tooltip_left     = ref();
  const arrow_left       = ref();

  watch(() => TooltipController.display, (value) => {
    if (value === true) {
      tooltipShow();
      return;
    }

    tooltipHide();
  });

  const tooltipShow = async () => {
    await nextTick();
    let tooltip_size  = tooltip.value.getBoundingClientRect();
    let target_size   = TooltipController.target.getBoundingClientRect();
    let target_center = (target_size.width / 2);
    tooltip_position.value = 'tooltip-bottom';

    tooltip_left.value = (target_size.left + (target_size.width / 2) - (tooltip_size.width / 2));
    tooltip_top.value  = target_size.bottom + 3;

    if ((TooltipController.position === 'top' && tooltip_top.value > 0) || tooltip_top.value + tooltip_size.height > document.body.clientHeight) {
      tooltip_top.value      = target_size.top - tooltip_size.height;
      tooltip_position.value = 'tooltip-top';
      tooltip_top.value     -= 5;
    }

    if (tooltip_left.value + tooltip_size.width > document.body.clientWidth) {
      tooltip_left.value      = target_size.right - tooltip_size.width;
      arrow_left.value        = tooltip_size.width - target_center;
      tooltip_position.value += '-left';
    }
    else if (tooltip_left.value < 0) {
      tooltip_left.value      = target_size.left;
      arrow_left.value        = target_center;
      tooltip_position.value += '-right';
    } else {
      tooltip_position.value += '-center';
      arrow_left.value        = tooltip_size.width - target_center;
      arrow_left.value        = tooltip_size.width / 2;
    }

    tooltip_status.value = 'tooltip-visible';
  }

  const tooltipHide = () => {
    tooltip_status.value = 'tooltip-hidden';
  }
</script>
